import { ValueOf } from '@shared/types/common.ts';

const CountryCodesDictionary = {
  IT: 'IT',
  EN: 'EN',
  ES: 'ES',
  DE: 'DE',
} as const;

export const AppLanguageCountryCodes = {
  IT: CountryCodesDictionary.IT,
  EN: CountryCodesDictionary.EN,
  ES: CountryCodesDictionary.ES,
  DE: CountryCodesDictionary.DE,
} as const;

export type AppLanguageCountryCode = ValueOf<typeof AppLanguageCountryCodes>;

export const AppLanguageLocales = {
  [AppLanguageCountryCodes.IT]: 'it',
  [AppLanguageCountryCodes.EN]: 'en',
  [AppLanguageCountryCodes.ES]: 'es',
  [AppLanguageCountryCodes.DE]: 'de',
} as const satisfies Record<AppLanguageCountryCode, string>;

export const UserCountryCodes = {
  IT: CountryCodesDictionary.IT,
  ES: CountryCodesDictionary.ES,
  DE: CountryCodesDictionary.DE,
} as const;

const DEFAULT_USER_COUNTRY_CODE = UserCountryCodes.IT;

export type UserCountryCode = ValueOf<typeof UserCountryCodes>;

export function resolveUserCountryCode(countryCode: UserCountryCode | null): UserCountryCode {
  return countryCode ?? DEFAULT_USER_COUNTRY_CODE;
}

export function parseCountryCodeFromToken(value: unknown): UserCountryCode | null {
  if (typeof value !== 'string') {
    return null;
  }

  for (const countryCode of Object.values(UserCountryCodes)) {
    if (countryCode === value) {
      return countryCode;
    }
  }

  return null;
}
